import React from 'react';
import { connect } from "react-redux";

import AppLayout from "../components/AppLayout";
import { submitIpcRequest } from "../store/actions/consoleActions";
import DynamoDBQueryPanel from "../components/DynamoDBQueryPanel";

function DynamoDBPage(props) {
    return (
        <AppLayout title="DynamoDB">
            <DynamoDBQueryPanel
                submitRequest={props.submitIpcRequest}
            />
        </AppLayout>
    )
}

export default connect(null, {submitIpcRequest})(
    DynamoDBPage
);
